import { render, staticRenderFns } from "./InventoryDetails.vue?vue&type=template&id=2207cd62&scoped=true&"
import script from "./InventoryDetails.vue?vue&type=script&lang=js&"
export * from "./InventoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2207cd62",
  null
  
)

export default component.exports